import { RumConfiguration } from '@picsart/datadog-rum';
import { getContext } from '@picsart/miniapps-sdk';

// Datadog RUM SDK Initialization Parameters
// Configuration parameters for Datadog RUM (Real User Monitoring) SDK
// Controls tracking settings, sampling rates, and application identifiers for user behavior monitoring
const dataDogConfig: RumConfiguration = {
  initParams: {
    version: import.meta.env.VITE_APP_VERSION,
    service: import.meta.env.VITE_APP_DD_SERVICE,
    env: import.meta.env.VITE_APP_DD_ENV,
  },
  globalContext: {
    type: 'miniapp',
    team: 'drive',
  },
  getContext,
};

export default dataDogConfig;
